import { AccordionItem as ChakraAccordionItem } from '@chakra-ui/react';

type AccordionItemProps = React.ComponentProps<typeof ChakraAccordionItem>;

const AccordionItem = ({
  children,
  ...props
}: Readonly<AccordionItemProps>) => {
  return <ChakraAccordionItem {...props}>{children}</ChakraAccordionItem>;
};

export default AccordionItem;
